export type Project = {
    id: number;
    category: string;
    title: string;
    target: string;
    year: string;
    summary: string;
    tags: string[];
    result: string;

    background: string;
    problem: string;
    solution: string;
    tech: string[];
    outcome: string;
    isEdit: boolean;
    enabled: boolean;
};

export const projects: Project[] = [
  {
    id: 49,
    category: 'web-mobile',
    title: '현대자동차그룹 대규모 제조 공장 APS 3.0 생산계획 시스템 구축',
    target: 'WEB & MOBILE',
    year: '2025 ~ 2026',
    summary: 'ERP·MES와 연동되는 차세대 APS 3.0 기반 생산계획 시스템을 구축하여 대규모 제조 공장의 생산 계획 수립 및 운영 관리 체계를 고도화한 프로젝트',
    tags: ['Manufacturing', 'APS', 'Enterprise', 'SCM', 'Platform'],
    result: '차세대 APS 3.0 생산계획 플랫폼 구축을 통해 제조 공장 생산 운영 데이터 관리 및 생산 계획 수립 체계 개선',
    background: '기존 APS II 시스템은 장기간 운영되면서 기술 구조 노후화와 유지보수 부담이 증가했으며 ERP 및 MES 시스템과의 데이터 연동 복잡도가 높아 생산 계획 업무 전반을 차세대 구조로 재구축할 필요가 있었음',
    problem: '생산 계획 기능이 여러 시스템에 분산되어 ERP·MES 데이터 연동 관리가 복잡하고 생산 계획 데이터 처리 및 운영 관리 효율이 낮은 문제가 존재',
    solution: '기존 APS II 시스템을 분석하여 APS 3.0 아키텍처 기반 생산계획 플랫폼을 설계하고 ERP·MES와의 EAI 인터페이스 구조를 적용하여 생산 계획 수립, 납기 관리, 협력사 관리 등 핵심 기능을 통합 관리할 수 있는 시스템을 구축',
    tech: ['Spring Boot', 'React', 'PostgreSQL', 'Batch', 'Grid', 'EAI'],
    outcome: '차세대 APS 생산계획 플랫폼을 구축하여 공장 생산 운영 데이터를 통합 관리하고 ERP·MES와 연동되는 안정적인 생산 계획 시스템 기반 확보',
    isEdit: true,
    enabled: true
  },
  {
    id: 48,
    category: 'web-mobile',
    title: '인테리어 파트너 매칭 플랫폼 Interior House MVP 구축',
    target: 'WEB & MOBILE',
    year: '2026',
    summary: '인테리어 시공을 원하는 고객과 검증된 인테리어 업체를 연결하고 상담·견적 요청까지 지원하는 모바일 기반 인테리어 매칭 플랫폼 MVP 구축 프로젝트',
    tags: ['Interior', 'Matching', 'Platform', 'Mobile'],
    result: '인테리어 사례 탐색과 파트너 업체 연결이 가능한 모바일 매칭 플랫폼 구축',
    background: '기존 인테리어 시공 시장은 업체 정보가 분산되어 있고 실제 시공 사례와 업체 정보를 비교하기 어려워 고객의 의사결정 과정이 비효율적인 문제가 있었음',
    problem: '고객이 스타일, 공간 유형, 가격대, 지역, 시공 경험 등을 기준으로 업체를 객관적으로 비교하기 어렵고 상담 및 견적 요청까지 이어지는 통합 서비스 흐름이 부족했음',
    solution: '모바일 앱 기반으로 인테리어 사례 탐색, 파트너 업체 프로필 조회, 상담 및 견적 요청, 진행 상태 관리 기능을 통합 제공하고 사용자 중심 UI/UX를 적용한 인테리어 매칭 플랫폼 MVP를 구축',
    tech: ['React', 'Spring Boot', 'Android', 'iOS', 'Figma'],
    outcome: '인테리어 시공 사례와 업체 정보를 하나의 플랫폼에서 탐색하고 상담 요청까지 연결할 수 있는 서비스 구조를 마련하여 향후 업체 확장 및 기능 고도화 기반 확보',
    isEdit: true,
    enabled: true
  },
  {
    id: 47,
    category: 'web-mobile',
    title: 'CVNET 스마트 미러 IoT 생활정보 서비스 플랫폼 구축',
    target: 'WEB & MOBILE',
    year: '2022',
    summary: '스마트 미러 장비와 모바일 앱, 관리 서버를 연동하여 날씨·교통·뉴스·단지 정보 등 생활 정보를 통합 제공하는 IoT 기반 스마트홈 서비스 플랫폼 구축 프로젝트',
    tags: ['IoT', 'SmartHome', 'Mobile', 'Platform'],
    result: '스마트 미러 장비와 모바일 앱, 관리 서버를 연동한 IoT 기반 생활정보 서비스 플랫폼 구축',
    background: '아파트 단지에서 발생하는 공지, 택배, 방문자 정보 등 다양한 단지 정보를 세대 내에서 직관적으로 확인할 수 있는 서비스가 부족했으며 생활 정보 또한 여러 서비스에 분산되어 있어 통합된 스마트홈 정보 서비스가 필요했음',
    problem: '단지 정보와 생활 정보가 여러 서비스에 분산되어 사용자 접근성이 낮고, 세대 내에서 직관적으로 확인할 수 있는 스마트 디바이스 기반 서비스가 부족',
    solution: 'Android 기반 스마트 미러 장비 UI를 구축하고 외부 API와 단지 서버 데이터를 연동하여 생활 정보를 통합 제공하며, 모바일 앱과 장비 간 세대 인증 구조를 설계하고 Bluetooth 기반 체중계 연동 및 음성 인식 기능을 적용한 IoT 서비스 플랫폼 구현',
    tech: ['Android', 'Kotlin', 'iOS', 'IoT', 'Bluetooth', 'REST API'],
    outcome: '스마트 미러 장비와 모바일 앱, 관리 서버가 연동되는 IoT 기반 스마트홈 서비스 구조를 구축하고 생활 정보와 단지 정보를 통합 제공하는 플랫폼 기반 마련',
    isEdit: true,
    enabled: true
  },
  {
    id: 46,
    category: "mobile",
    title: "현대 모바일·웹 교육시스템(Global eCampus) 구축",
    target: "WEB & MOBILE",
    year: "2017",
    summary: "현대 연수 프로그램(어학연수·사이버연수·화상어학)을 통합 관리하는 모바일·웹 기반 교육 시스템(Global eCampus) 구축 프로젝트",
    tags: ["Education", "LMS", "Mobile", "Web"],
    result: "교육 과정 데이터 표준화 및 학습 관리 자동화를 통한 교육 운영 효율 향상",
    background: "어학연수, 사이버 연수, 화상어학 프로그램 등 다양한 교육 데이터를 통합 관리하고 학습자·교사·관리자가 함께 활용할 수 있는 통합 교육 플랫폼 구축 필요",
    problem: "교육 과정 유형별 관리 방식이 분산되어 있어 학습 이력 관리, 진도 관리, 교육 성과 분석을 일관된 기준으로 관리하기 어려운 문제 존재",
    solution: "모바일·웹 기반 LMS 플랫폼 구축을 통해 어학연수·온라인 강의·화상 수업을 통합 관리하고 학습 유형별 수강 관리, 진도·출결·성취도 산출 로직을 설계. 관리자 시스템을 통해 과정·강사·수강자·콘텐츠 관리 및 통계 리포트 기능 제공",
    tech: ["Android", "iOS", "Spring", "Java", "JavaScript"],
    outcome: "교육 과정 데이터 표준화 및 학습 관리 자동화를 통해 교육 운영 효율과 학습 접근성 향상",
    isEdit: true,
    enabled: true
  },
  {
    id: 45,
    category: 'mobile',
    title: '현대 방문 예약 반응형 모바일웹 시스템 구축',
    target: 'WEB & MOBILE',
    year: '2019 ~ 2020',
    summary: '현대 본사 및 연구소 출입을 위한 방문 예약, 승인, 출입 이력 관리를 PC·모바일 환경에서 통합 운영할 수 있는 반응형 모바일웹 시스템 구축 프로젝트',
    tags: ['MobileWeb', 'Reservation', 'Responsive', 'Admin'],
    result: '방문 예약 프로세스 표준화 및 모바일 환경 최적화를 통한 운영 효율 향상',
    background: '기존 방문 신청 및 출입 관리 방식은 예약 현황 파악, 승인 관리, 출입 이력 추적에 한계가 있었으며 사업장별 상이한 출입 정책과 모바일 환경 대응 부족으로 통합 방문 예약 시스템 구축 필요',
    problem: '수기 신청 또는 단순 시스템 기반 운영으로 인해 방문 예약, 승인, 변경, 취소, 출입 처리까지 전 과정을 일관되게 관리하기 어렵고 해외 법인 확장에도 구조적 한계 존재',
    solution: 'PC·모바일 통합 반응형 웹 기반 방문 예약 플랫폼 구축. 방문 예약, 변경, 취소, 완료 처리와 상태 이력 관리 기능을 설계하고 관리자 시스템을 통해 승인, 반려, 조회, 검색, 출입 로그 및 공지 관리 기능 제공. 사업장 및 해외 법인 확장을 고려한 공통 구조와 정책 분리 방식 적용',
    tech: ['Responsive Web', 'Mobile Web', 'Admin System', 'Multilingual', 'Publishing'],
    outcome: '본사 및 연구소 방문 예약 프로세스 표준화, 방문 상태 실시간 관리 체계 구축, 모바일 신청 편의성 향상 및 해외 법인 확장 기반 확보',
    isEdit: true,
    enabled: true
  },
  {
    id: 44,
    category: 'mobile',
    title: '기아 모바일 설문 및 통계 시스템 구축',
    target: 'WEB & MOBILE',
    year: '2018',
    summary: '모바일 환경에서 설문 참여와 결과 통계를 확인할 수 있는 기아모터스 모바일 설문 시스템 구축 프로젝트',
    tags: ['Mobile', 'Survey', 'Statistics'],
    result: '모바일 기반 설문 수집 및 통계 확인 기능 제공으로 사용자 참여 편의성 향상',
    background: '기존 설문 및 의견 수집 방식의 접근성과 참여율을 높이기 위해 모바일 환경에서 설문 참여와 결과 확인이 가능한 시스템 구축 필요',
    problem: '기존 설문 방식은 접근성이 제한적이며 참여 데이터의 실시간 수집 및 관리가 어려워 효율적인 통계 분석에 한계 존재',
    solution: '모바일 애플리케이션을 통해 설문 참여, 설문 리스트 조회, 설문 응답 관리 및 결과 통계 확인 기능을 제공하는 하이브리드 모바일 앱 구축',
    tech: ['Android', 'iOS', 'Web', 'Hybrid App', 'Mobile', 'Design'],
    outcome: '모바일 기반 설문 참여 환경 구축으로 사용자 접근성과 설문 데이터 수집 효율 향상',
    isEdit: true,
    enabled: true
  },
  {
    id: 43,
    category: 'mobile',
    title: '두산 IOT 모바일앱 구축',
    target: 'WEB & MOBILE',
    year: '2018',
    summary: '위치 데이터를 활용해 실시간 장비 현황 조회 및 제어를 지원하는 두산 IOT 모바일앱 구축 프로젝트',
    tags: ['IOT', 'Mobile', 'Monitoring', 'Control'],
    result: '실시간 장비 현황 조회 및 제어 기능 제공을 통한 운영 편의성 강화',
    background: '장비의 위치 정보와 상태 정보를 모바일 환경에서 실시간으로 확인하고 제어할 수 있는 현장 중심의 IOT 서비스 구축 필요',
    problem: '기존 장비 운영 환경에서는 위치 기반 장비 현황 파악과 상태 조회, 제어 기능을 통합적으로 제공하는 모바일 서비스가 부족하여 현장 대응 및 운영 효율에 한계 존재',
    solution: '지도 기반 장비 위치 시각화와 장비별 현황 정보 조회, 상태 확인 및 제어 기능을 제공하는 하이브리드 모바일앱을 구축하고 Android 및 iOS 환경을 지원하는 모바일 UI와 운영 화면을 구성',
    tech: ['Android', 'iOS', 'Web', 'Hybrid App'],
    outcome: '위치 데이터 기반의 실시간 장비 모니터링 및 제어 환경 구축으로 현장 접근성과 운영 효율 향상',
    isEdit: true,
    enabled: true
  },
  {
    id: 42,
    category: 'web-mobile',
    title: 'wassup – 태블릿 기반 스마트 방문객 관리 솔루션',
    target: 'WEB & MOBILE',
    year: '2020',
    summary: '태블릿 기반 비대면 방문객 등록·출입 인증과 관리자 웹을 통해 방문 신청, 문서 커스터마이징, 알림 연계, 출입 이력 관리를 통합 제공하는 스마트 방문객 관리 솔루션 구축 프로젝트',
    tags: ['VisitorManagement', 'Security', 'SaaS', 'Enterprise'],
    result: '수기 방명록을 디지털 전환하여 개인정보 보호 수준 강화 및 방문객 관리 업무 효율 향상',
    background: '종이 방명록 기반 방문객 관리 방식은 개인정보 노출 위험과 운영 비효율이 동시에 존재하여 기업 환경에 적합한 비대면 방문객 관리 시스템이 필요했음',
    problem: '수기 기반 방문객 기록으로 개인정보 노출 위험이 존재하고 방문객 집중 시 대기 시간 증가 및 관리 효율 저하 문제 발생',
    solution: '태블릿 기반 방문객 등록 및 출입 인증 시스템과 관리자 웹을 구축하여 방문 신청, 출입 이력 관리, 문서 커스터마이징 및 알림 기능을 통합 제공하는 방문객 관리 플랫폼 구현',
    tech: ['Java', 'Spring Boot', 'React', 'MySQL', 'jQuery', 'JavaScript'],
    outcome: '비대면 방문객 관리 프로세스를 구축하여 개인정보 보호 수준과 리셉션 운영 효율을 동시에 개선하고 다양한 시설에 적용 가능한 솔루션 기반 확보',
    isEdit: true,
    enabled: true
  },
  {
    id: 41,
    category: 'web-mobile',
    title: '현대자동차그룹 설비 점검 NFC 기반 모바일 업무 시스템 구축',
    target: 'WEB & MOBILE',
    year: '2002',
    summary: '현대자동차그룹 생산 현장의 설비 점검 업무를 NFC 기반으로 식별하고 모바일에서 점검 입력·이력·진행 현황을 통합 관리하는 현장 중심 업무 시스템 구축',
    tags: ['NFC', 'FacilityInspection', 'FieldWork', 'MobileSystem', 'Workflow'],
    result: '설비 점검 업무의 모바일 전환과 점검 프로세스 표준화를 통해 현장 업무 편의성과 데이터 관리 효율을 개선',
    background: '수기/종이 문서 중심 점검과 분산된 이력 관리로 설비 식별·집계·공유가 비효율적이었고, 이상 발생 시 조치 이력 추적과 현장-관리자 간 정보 전달 지연 문제가 지속되어 모바일 기반의 시스템화가 필요했음',
    problem: '설비 식별 및 점검 이력 관리 비효율, 점검 결과의 즉시 공유·집계 어려움, 이상 발생 항목의 기록/추적 한계, 설비별 점검 기준 상이로 인한 현장 작업자의 점검 항목 확인 불편',
    solution: 'NFC 태그 기반 설비 식별로 점검 대상 자동 조회를 구현하고, 설비별 점검 항목 리스트/상세 입력 화면을 모바일에 최적화하여 정상/이상 선택 및 수치 입력(기준값 포함) UI를 제공하며, 사진 첨부와 결과 저장/제출 프로세스를 포함한 점검 이력 관리 및 진행 현황(완료/미완료) 관리 구조를 구축',
    tech: ['Android', 'iOS', 'NFC', 'Mobile App', 'Tablet'],
    outcome: '현장 점검 업무를 모바일에서 일관되게 수행할 수 있는 체계를 마련하고, 설비별 점검 이력과 이상 항목 기록/추적이 가능한 구조를 확보하여 점검 데이터 신뢰성과 운영 관리 효율을 향상',
    isEdit: true,
    enabled: true
  },
  {
    id: 40,
    category: 'web-mobile',
    title: 'OnePick 골프 라운딩 보조 모바일 애플리케이션',
    target: 'WEB & MOBILE',
    year: '2025 ~ 2026',
    summary: '골프 라운딩 시 아너 선정, 팀 분할, 캐디피 분배를 재미있고 간편하게 제공하는 모바일 애플리케이션 구축 프로젝트',
    tags: ['Golf', 'MobileApp', 'UX', 'Entertainment'],
    result: '골프 라운딩 전 과정의 편의성과 즐거움을 향상시키는 인터랙션 중심 모바일 서비스 구축',
    background: '기존 제비뽑기 및 구두 합의 방식의 불편함을 해소하고 골프 라운딩 경험을 보다 즐겁고 공정하게 만들기 위한 모바일 서비스 필요',
    problem: '아너 선정, 팀 분할, 캐디피 분배 과정이 비공식적이고 번거로우며 사용자 경험이 단조로움',
    solution: '랜덤 알고리즘 기반 아너 선정, 팀 분할, 캐디피 자동 분배 기능과 애니메이션 및 제스처 기반 인터랙션을 적용한 모바일 앱 구축',
    tech: ['Flutter', 'Dart', 'Node.js', 'MySQL', 'AWS S3', 'Figma'],
    outcome: '직관적인 UX와 시각·청각 효과를 통해 라운딩 몰입도와 사용자 만족도 향상',
    isEdit: true,
    enabled: true
  },
  {
    id: 39,
    category: "web-mobile",
    title: "전문대학 진로·진학 통합상담시스템 꿈꾸GO 고도화 및 유지관리",
    target: "WEB & MOBILE",
    year: "2025 ~ 2026",
    summary: "전국 전문대학 입시·전공·직업 데이터를 기반으로 학생·교사·학부모가 활용하는 진로·진학 통합상담시스템 ‘꿈꾸GO’의 기능 고도화 및 통합 운영·유지관리 프로젝트",
    tags: ["Education", "Consulting", "Platform", "Public"],
    result: "입시·진학 데이터 신뢰도 향상 및 안정적인 상담 서비스 운영 환경 구축",
    background: "기존 구축된 꿈꾸GO 시스템의 입시·전공·직업 데이터를 최신 입시 정책과 전형 기준에 맞게 고도화하고 사용자 상담 기능과 관리자 운영 기능을 개선하여 보다 정확한 진로·진학 상담 서비스를 제공할 필요가 있었음",
    problem: "대학별 전형 방식과 입시 데이터 구조가 복잡하여 상담 계산 로직 유지보수가 어려웠으며, 최신 입시 데이터 반영과 사용자 상담 기능의 편의성 개선, 관리자 운영 효율 향상이 필요한 상황이었음",
    solution: "전문대학 입시·전공·직업 데이터를 수집·검증·표준화하고 대학별 수시·정시 전형 기준을 반영한 입학점수 산출 로직을 고도화하였다. 사용자(Web/Mobile) 상담 기능 및 UI/UX를 개선하고 관리자(Admin) 운영 시스템과 권한 관리 기능을 구축하여 통합 운영·유지관리 체계를 마련하였다",
    tech: ["Spring Boot", "Java", "Thymeleaf", "Node.js", "React", "Electron", "Gradle"],
    outcome: "전문대학 입시·진로 데이터 표준화를 통해 상담 데이터 신뢰도를 향상시키고 복잡한 대학별 전형 계산 로직을 자동화하여 상담 정확도와 업무 효율을 개선하였으며, 사용자 중심 UI/UX 개선과 통합 유지관리 체계를 통해 안정적인 서비스 운영 기반을 확보",
    isEdit: true,
    enabled: true
  },
  {
    id: 38,
    category: 'ai',
    title: 'OnePutt AI 기반 논터치 인식 기능 및 3D 시각화 기술을 접목한 고도화 및 유지보수',
    target: 'A.I',
    year: '2025 ~ 2026',
    summary: 'OnePutt 모바일 애플리케이션에 AI 비전 기반 논터치 인식 기능과 3D 시각화 기술을 적용하여 퍼팅 라인 측정 정확도와 사용자 경험을 고도화한 프로젝트',
    tags: ['AI', 'ComputerVision', '3D', 'SportsTech'],
    result: '퍼팅 라인 측정 정확도 향상 및 논터치 UX와 3D 시각화를 통한 사용자 경험 강화',
    background: '기존 퍼팅 측정 서비스의 정확도와 사용자 몰입도를 개선하기 위해 AI 비전 기술과 3D 시각화 기술을 적용한 고도화가 필요했음',
    problem: '터치 중심 조작으로 인해 측정 흐름이 단절되고 퍼팅 결과를 직관적으로 이해하기 어려우며, 볼과 홀컵 인식 정확도 및 사용 편의성 개선이 필요한 상황이었음',
    solution: 'AI 비전 기술을 활용해 볼과 홀컵 자동 인식 및 주요 기능의 논터치 조작 기능을 구현하고, 퍼팅 결과를 3D 시각화하여 실측 라인과 가이드 라인을 직관적으로 구분할 수 있도록 UI/UX를 고도화',
    tech: ['Swift', 'TypeScript', 'Next.js', 'iOS', 'Figma'],
    outcome: '논터치 UX 도입으로 사용 흐름을 자연스럽게 개선하고, 3D 시각화 기반 분석 기능을 통해 퍼팅 결과 이해도와 서비스 확장성을 높임',
    isEdit: true,
    enabled: true
  },
  {
    id: 37,
    category: "ai",
    title: "슈퍼캐디 AI 골프 거리측정·홀맵·스윙분석 모바일 애플리케이션",
    target: "A.I",
    year: "2024",
    summary: "스마트폰 카메라 기반 거리측정, 홀맵 제공, 스윙 분석 및 AI 골프 샷 궤적 분석 기능을 제공하는 Super Caddie 모바일 앱 개발 프로젝트",
    tags: ["AI", "ComputerVision", "Mobile", "SportsTech", "Golf"],
    result: "모바일 환경에서 촬영 기반 거리측정, 홀 정보 제공, AI 스윙 분석까지 통합된 골프 서비스 UX 구축",
    background: "골프 사용자들이 별도 장비 없이 스마트폰만으로 거리측정, 샷 분석, 코스 정보를 확인할 수 있는 모바일 서비스 수요가 증가하면서 AI 기반 골프 분석 서비스 구축 필요",
    problem: "필드 환경에서 작은 골프공을 정확히 인식하고 거리 및 궤적을 분석해야 하는 기술적 난이도가 존재하며, 촬영–분석–결과 확인까지의 사용자 흐름을 모바일 환경에 최적화 필요",
    solution: "스마트폰 카메라 기반 거리측정 기능과 골프공 궤적 트래킹을 구현하고 AI 분석을 통해 샷 구질 및 스윙 데이터를 시각화. 홀맵 기반 코스 정보 제공, 분석 결과 저장 및 공유 기능, 사용자 피드백 기반 데이터 축적 구조를 설계하여 서비스 운영 기반 구축",
    tech: ["Android", "iOS", "Spring Boot", "AWS", "AI/Computer Vision", "Video Processing"],
    outcome: "모바일 환경에서 골프 거리측정, 샷 궤적 분석, 홀 정보 제공 기능을 통합한 AI 골프 서비스 구현 및 데이터 기반 기능 고도화 구조 확보",
    isEdit: true,
    enabled: true
  },
  {
    id: 36,
    category: 'web-mobile',
    title: '레미안 스마트 주차장 APP 구축',
    target: 'WEB & MOBILE',
    year: '2022',
    summary: '입·출차 인식, 주차 유도, 전기차 충전 관리, 디스플레이 연동을 통합 관리하는 스마트 주차장 플랫폼 구축 프로젝트',
    tags: ['SmartParking', 'IoT', 'EV', 'Platform', 'Mobile'],
    result: '주차 흐름 자동화 및 사용자 편의성 향상, 주차장 운영 효율 개선',
    background: '대규모 공동주택 및 시설에서 주차 혼잡 문제와 전기차 증가에 대응하기 위한 지능형 주차 관리 시스템 필요',
    problem: '주차면 현황 파악의 어려움, 방문 차량 관리 비효율, 전기차 충전 및 주차 유도 시스템 부족',
    solution: '번호판 인식 기반 입·출차 관리, 전기차 충전 관리, 모바일 앱과 디스플레이를 연동한 스마트 주차장 통합 플랫폼 구축',
    tech: ['Android', 'iOS', 'Spring Boot', 'Java', 'React', 'TypeScript'],
    outcome: '주차 관리 자동화 및 스마트 주차장 확장을 위한 플랫폼 기반 구축',
    isEdit: true,
    enabled: true
  },
  {
    id: 35,
    category: 'web-mobile',
    title: '스마트 양식장 플랫폼 FICL 구축',
    target: 'WEB & MOBILE',
    year: '2022 ~ 2023',
    summary: 'IoT 센서와 AI 분석을 기반으로 양식장 환경 데이터를 실시간 관리하고 생산성 향상을 지원하는 스마트 양식장 플랫폼 구축 프로젝트',
    tags: ['SmartFarm', 'Aquaculture', 'IoT', 'AI', 'Platform'],
    result: '양식장 환경 데이터의 실시간 모니터링과 데이터 기반 생산 관리 플랫폼 구축',
    background: '글로벌 수산업 패러다임이 어선어업 중심에서 양식업 중심으로 빠르게 전환되면서 수온·수질·산소량 등 어장 환경을 데이터 기반으로 관리할 수 있는 스마트 양식 관리 시스템 필요성 증가',
    problem: '기존 양식장은 경험 중심으로 운영되어 환경 변화 대응이 어렵고 질병 발생 및 생산성 저하 위험이 존재',
    solution: 'IoT 센서를 통해 수온, 산소량, 수질 등 어장 환경 데이터를 실시간 수집하고 모바일 앱과 웹 시스템에서 모니터링 및 관리할 수 있는 플랫폼을 구축하고, AI 기반 분석을 통해 사료량 및 양식 환경 관리 데이터를 제공',
    tech: ['Android', 'iOS', 'Spring Boot', 'Node.js', 'Next.js', 'TypeScript'],
    outcome: '데이터 기반 스마트 어장 관리 체계를 구축하여 양식 생산성 향상과 운영 효율 개선 기반 마련',
    isEdit: true,
    enabled: true
  },
  {
    id: 34,
    category: "ai",
    title: "픽셀투폴리(PIXEL2POLY) - 실세계와 가상세계를 연결하는 XR 중개 플랫폼",
    target : "WEB & MOBILE",
    year : "2024",
    summary : "AI 기반 3D 콘텐츠 생성과 XR 체험 기능을 통합하여 실세계와 가상세계를 연결하는 XR 3D 콘텐츠 생성·유통·체험 플랫폼 구축 프로젝트",
    tags : ["XR", "AI", "3D", "Metaverse", "Platform"],
    result : "AI 기반 3D 콘텐츠 생성, XR 체험, 콘텐츠 거래가 가능한 XR 통합 플랫폼 구축 및 정식 서비스 오픈",
    background : "메타버스와 XR 콘텐츠 수요 증가에 따라 일반 사용자가 3D 콘텐츠를 생성·유통·체험할 수 있는 플랫폼 필요성이 증가하였으며, 3D 에셋 생성 및 유통 채널 부족 문제를 해결하기 위한 중개 플랫폼 구축이 요구됨",
    problem : "일반 사용자가 3D 콘텐츠를 제작하고 유통할 수 있는 환경이 부족했으며, 3D 에셋 시장이 파편화되어 콘텐츠 생성·유통·체험 과정이 분리되어 있었음",
    solution : "NeRF 기반 3D Reconstruction 기술과 생성형 AI 기반 Text/Image to 3D 기술을 적용하여 3D 콘텐츠 자동 생성 기능을 구현하고, Google Anchor 기반 AR 위치 매핑과 XR 체험 기능을 통합한 3D 콘텐츠 중개 플랫폼을 구축하였다",
    tech : ["Deep Learning", "NeRF", "Python", "Spring Boot", "Elasticsearch", "Next.js", "Blender"],
    outcome: "AI 기반 3D 콘텐츠 생성과 XR 체험 기능을 통합한 플랫폼을 구축하여 XR 콘텐츠 생태계 확장 기반을 마련하고 정부 지원 및 후속 투자 유치에 성공",
    isEdit: true,
    enabled: true
  },
  {
    id: 33,
    category: "web-mobile",
    title: "경기신용보증재단 비대면 플랫폼 서비스 구축",
    target: "GOVERNMENT",
    year: "2022 ~ 2023",
    summary: "경기신용보증재단의 보증 신청, 심사, 전자약정, 서류제출 등을 비대면으로 처리할 수 있도록 모바일 앱(APP)과 웹 서비스를 통합 구축한 공공 금융 플랫폼 프로젝트",
    tags: ["Fintech", "Public", "NonFaceToFace", "Platform"],
    result: "보증 업무의 비대면 전환을 통해 민원 편의성과 업무 처리 효율을 향상",
    background: "기존 보증 신청 및 상담 업무가 지점 방문 중심으로 운영되어 이용자 불편이 발생했으며, 공공 금융 서비스의 디지털 전환을 위해 비대면 플랫폼 구축이 필요했음",
    problem: "보증 신청, 심사, 서류 제출, 약정 등 주요 업무가 오프라인 중심으로 운영되어 처리 시간이 길고 이용자 접근성이 낮았음",
    solution: "모바일 앱(APP)과 비대면 창구 웹 서비스를 구축하여 보증 신청부터 심사, 전자약정, 서류 제출, 채무조정까지 전 과정을 온라인으로 처리할 수 있도록 시스템을 설계하고 비대면 인증 및 전자서명 프로세스를 적용",
    tech: ["Android", "Kotlin", "React Native", "TypeScript", "iOS"],
    outcome: "지점 방문 없이 보증 업무 전 과정을 비대면으로 처리할 수 있는 공공 금융 플랫폼을 구축하여 사용자 편의성과 서비스 접근성을 개선",
    isEdit: true,
    enabled: true
  },
  {
    id: 32,
    category: "web-mobile",
    title: "서울대학교 중앙도서관 모바일 앱 개발",
    target: "WEB & MOBILE",
    year: "2022",
    summary: "서울대학교 중앙도서관 이용자를 대상으로 통합검색, 대출/예약, 좌석·시설 예약, 알림 및 개인화 서비스를 제공하는 모바일 앱 구축 프로젝트",
    tags: ["Mobile", "Library", "Reservation", "University"],
    result: "도서관 이용·예약·알림 기능을 모바일 앱으로 통합하여 사용자 편의성과 서비스 접근성 향상",
    background: "도서관 이용 정보(대출/예약/연체), 좌석·시설 예약, 공지 및 알림 기능이 여러 시스템에 분산되어 있어 모바일 환경에서 통합적으로 제공할 필요가 있었음",
    problem: "도서관 서비스가 분산되어 있어 이용 흐름이 단절되고 좌석·시설 예약 및 이용 정보 확인을 위한 사용자 중심 모바일 UI/UX가 부족했음",
    solution: "홈(MY탭), 피드, 통합검색, 마이라이브러리, 좌석·시설예약 기능을 중심으로 모바일 앱을 구축하고 로그인, 푸시 알림, WebView 기반 외부 서비스 연계를 통해 이용 흐름을 표준화하였다",
    tech: ["Android", "Kotlin", "Objective-C", "iOS"],
    outcome: "도서관 이용, 예약, 알림 기능을 모바일 앱에서 통합 제공하여 서비스 접근성을 높이고 사용자 이용 경험과 운영 효율을 개선",
    isEdit: true,
    enabled: true
  },
  {
    id: 31,
    category: "e-document",
    title: "화물자동차공제 이미지시스템 개발",
    target: "GOVERNMENT",
    year: "2024 ~ 2025",
    summary: "전자서식(OZ), 이미지, 동영상 데이터를 통합 처리하는 공공기관 이미지 시스템 고도화 구축 프로젝트",
    tags: ["ImageSystem", "E-Document", "Public", "SystemUpgrade"],
    result: "전자문서·이미지·동영상 통합 관리 환경 구축 및 업무 처리 효율 향상",
    background: "기존 이미지 및 전자문서 시스템의 노후화로 인해 성능 저하와 관리 효율 문제가 발생하였으며, 전자서식·이미지·동영상 데이터를 통합 관리할 수 있는 시스템 고도화가 필요했음",
    problem: "이미지, 문서, 동영상 처리 시스템이 분산되어 있어 조회 및 관리가 비효율적이었고 전자서식 발송 및 관리 기능도 별도 시스템으로 운영되어 업무 처리 과정이 복잡했음",
    solution: "HTML5 기반 이미지 뷰어 기능을 개선하고 이미지·문서 변환 시스템과 동영상 스트리밍 시스템을 연계하여 통합 조회·관리 기능을 구축하였다. 또한 전자서식(OZ Report) 발송 및 서명 처리 기능을 구현하고 사용자·권한 관리 및 로그 관리 기능을 추가하여 안정적인 운영 환경을 구축하였다",
    tech: ["Spring Boot", "Java", "OZ Report"],
    outcome: "이미지·문서·동영상 처리 시스템을 통합하여 업무 처리 효율을 개선하고 전자서식 기반 문서 처리 안정성과 시스템 확장성을 확보",
    isEdit: true,
    enabled: true
  },
  {
    id: 30,
    category: 'web',
    title: '한국가스기술공사 3D 모델 활용 시스템 개발',
    target: 'GOVERNMENT',
    year: '2024',
    summary: '천연가스 설비를 3D 모델로 가시화하고 웹 환경에서 설비 구조를 확인하고 활용할 수 있도록 구축한 3D 모델 기반 설비 관리 시스템',
    tags: ['3D', 'Visualization', 'Government', 'Plant'],
    result: '3D 모델 기반 설비 이해도 향상 및 정비·업무 효율 개선',
    background: '천연가스 설비 구조를 보다 직관적으로 이해하고 효율적인 유지보수 및 설비 관리 업무를 지원하기 위해 3D 모델 기반 시스템 구축 필요',
    problem: '기존 2D 도면 기반 설비 정보는 구조 파악과 정비 작업 과정에서 이해도가 낮고 현장 업무 활용에 한계 존재',
    solution: '3D 모델 변환 시스템과 웹 기반 3D 뷰어를 구축하여 설비 모델을 시각화하고 ERP 인사·조직 데이터와 연동하여 사용자 인증 및 설비 정보 접근 체계를 통합',
    tech: ['Spring Boot', 'Java', 'Python', 'Three.js', 'JavaScript'],
    outcome: '설비 정보를 3D로 직관적으로 제공하여 현업 이해도를 높이고 정비 및 업무 처리 효율을 개선',
    isEdit: true,
    enabled: true
  },
  {
    id: 29,
    category: "web-mobile",
    title: "호텔신라 VVIP 유료 멤버십(S Membership) 통합 운영 시스템 고도화",
    target: "WEB & MOBILE",
    year: "2024",
    summary: "호텔신라 VVIP 유료 멤버십(S Membership)의 예약·결제·혜택·포인트 정산을 통합 관리하는 온·오프라인 멤버십 운영 시스템 고도화 프로젝트",
    tags: ["Web", "Mobile", "Membership", "CRM"],
    result: "VVIP 멤버십 운영 정책 안정화 및 POS 결제 연동 기반 통합 혜택·포인트 처리 체계 구축",
    background: "호텔신라 VVIP 유료 멤버십 서비스는 온라인 서비스와 오프라인 POS 결제 환경이 분리되어 운영되어 혜택 적용 여부 확인, 포인트 반영 및 정산 과정에서 운영 리스크가 존재했으며, 예약 시스템과의 연계 부족 및 기존 데이터 구조 노후화로 인해 통합 운영 체계 개선 필요",
    problem: "객실·다이닝 결제 시 등급별 할인, 포인트 사용 한도, 중복 혜택 조건 등이 복합적으로 작용하면서 POS 결제 금액 계산 불일치와 포인트 재정산 오류 가능성이 존재하고 예약·결제·혜택·포인트 흐름이 일관되지 않은 문제 발생",
    solution: "호텔신라 VVIP 멤버십 등급 정책(할인율, 적립률, 사용 한도 등)을 재정의하고 POS 시스템과 멤버십 서버 간 실시간 연동 구조를 고도화. 결제 승인, 취소, 환불 등 다양한 시나리오에 대응하는 트랜잭션 기반 포인트 정산 구조를 구축하고 예약 시스템 연계를 통해 VVIP 전용 혜택이 예약 단계부터 자동 적용되도록 운영 흐름 재설계",
    tech: ["Java", "Spring", "JSP", "JavaScript", "jQuery", "Android", "iOS"],
    outcome: "VVIP 등급 정책이 안정적으로 반영되는 온·오프라인 통합 멤버십 운영 체계 구축, POS 결제와 멤버십 서버 간 데이터 정합성 향상 및 프리미엄 고객 경험 강화",
    isEdit: true,
    enabled: true
  },
  {
    id: 28,
    category: "web-mobile",
    title: "벡터 스포츠 솔루션 모바일 앱 개발",
    target: "WEB & MOBILE",
    year: "2023",
    summary: "스포츠 동작 영상을 분석하여 결과를 제공하는 벡터 스포츠 솔루션 모바일 앱 및 서버 시스템 개발 프로젝트",
    tags: ["Mobile", "Sports", "Video Analysis"],
    result: "모바일 환경에서 영상 분석 서비스를 이용할 수 있는 사용자 경험 및 서비스 운영 기반 구축",
    background: "스포츠 동작(투구 등) 영상 분석 서비스를 모바일 환경에서도 제공하기 위해 영상 촬영, 업로드, 분석 결과 확인까지의 전 과정을 지원하는 모바일 앱과 서버 시스템 구축 필요",
    problem: "모바일 플랫폼 부재로 인해 영상 분석 서비스 접근성이 제한되어 있었으며, 영상 제출 이후 분석 결과 확인 및 사용자 데이터 관리 경험이 일관된 흐름으로 제공되지 않는 문제 존재",
    solution: "모바일 앱에서 SNS 로그인, 영상 촬영 가이드, 영상 업로드, 분석 결과 확인까지의 사용자 흐름을 설계하고 서버 API를 통해 분석 요청 및 결과 데이터를 관리하도록 구현. 마이데이터 화면을 통해 분석 결과를 누적 관리하고 분석 성공/실패에 따른 사용자 안내 UX를 구축",
    tech: ["Android", "iOS", "Kotlin", "Objective-C", "Java", "Spring", "JavaScript"],
    outcome: "모바일 환경에서 스포츠 영상 분석 서비스 이용 접근성을 향상시키고 분석 결과 관리 기능을 통해 사용자 경험과 서비스 확장 기반 확보",
    isEdit: true,
    enabled: true
  },
  {
    id: 27,
    category: "web-mobile",
    title: "환기 청정기(IRUMI) 어플리케이션 개발",
    target: "WEB & MOBILE",
    year: "2023",
    summary: "환기 청정기 및 공기질 측정기를 모바일에서 제어하고 실시간 공기질 상태를 확인할 수 있는 IoT 연동 모바일 애플리케이션 개발 프로젝트",
    tags: ["Mobile", "IoT", "AirQuality"],
    result: "모바일 기반 기기 제어 및 공기질 모니터링 서비스 환경 구축",
    background: "환기 청정기 및 공기질 측정기를 사용자 모바일 환경에서 제어하고 공기질 상태를 실시간으로 확인할 수 있는 서비스 구축이 필요했으며, IoT 기기와 서버, 모바일 앱을 안정적으로 연동하는 시스템 요구가 발생",
    problem: "기기 제어 및 상태 모니터링을 위한 사용자 친화적인 모바일 인터페이스가 부재했고, 공기질 데이터 확인 및 기기 제어를 위한 통합 서비스 환경이 부족했음",
    solution: "Android 및 iOS 기반 모바일 애플리케이션을 개발하고 서버 API와 연동하여 공기질 데이터를 실시간으로 수신하고 기기 제어 기능을 구현. IoT 기기와 모바일 앱 간 연동 구조를 설계하고 사용자 중심 UI 흐름을 구성하여 서비스 사용성을 개선",
    tech: ["AWS", "Android", "Figma", "Spring Boot", "iOS"],
    outcome: "IoT 기기 연동 모바일 제어 환경을 구축하고 공기질 상태 확인 및 환기 청정기 제어 기능을 안정적으로 제공하여 사용자 편의성과 서비스 운영 안정성을 확보",
    isEdit: true,
    enabled: true
  },
  {
    id: 26,
    category: "web-mobile",
    title: "아나바다 물물교환 이커머스 플랫폼 고도화 및 통합 유지보수",
    target: "WEB & MOBILE",
    year: "2023",
    summary: "중고 명품 물물교환(교환권) 기반 이커머스 플랫폼의 핵심 기능 고도화와 안정적인 서비스 운영을 위한 통합 유지보수 프로젝트",
    tags: ["Platform", "E-commerce", "Maintenance"],
    result: "결제·검색·홈 UI·반품/환불 기능 고도화를 통해 운영 안정성과 사용자 경험 개선",
    background: "아나바다는 중고 명품 거래(물물교환/교환권 포함) 기반 이커머스 플랫폼으로 안정적인 서비스 운영을 유지하면서 결제, 검색, 홈 UI, 반품/환불, 카테고리 등 핵심 기능 개선이 지속적으로 요구되는 상황",
    problem: "결제 모듈 노후화로 최신 결제 환경 대응이 필요했으며, 홈 콘텐츠 관리 및 관리자 기능 보완, 검색/필터 사용성 개선, 부분반품·부분환불 정책 반영 등 서비스 운영 과정에서 기능 고도화 요구가 누적됨",
    solution: "결제 모듈 최신화와 결제 API 및 DB 마이그레이션을 수행하고 웹뷰 기반 결제 구조 개선과 기기·버전별 결제 테스트를 진행. 홈 화면 구조 개편과 관리자 홈 관리 기능을 추가하고 검색 화면 리뉴얼 및 필터 기능 고도화를 수행. 지갑 카테고리 및 관리자 관리 기능을 확장하고 APP/WEB/ADMIN 전 구간에 부분반품·부분환불 프로세스를 구현하여 서비스 운영 안정성을 강화",
    tech: ["Figma", "Android", "iOS", "Laravel", "PHP"],
    outcome: "결제·검색·홈·반품/환불 등 핵심 거래 흐름을 개선하여 서비스 안정성과 운영 효율을 향상시키고 정책 변화에 대응 가능한 플랫폼 운영 기반 확보",
    isEdit: true,
    enabled: true
  },
  {
    id: 25,
    category: "web-mobile",
    title: "전문대학 전공모아 모바일 앱 고도화 및 유지보수",
    target: "WEB & MOBILE",
    year: "2023",
    summary: "전문대학 전공·대학·입학 정보를 제공하는 전공모아 모바일 앱의 기능 고도화 및 안정적인 서비스 운영을 위한 유지보수 프로젝트",
    tags: ["Mobile", "Education", "Upgrade", "Maintenance"],
    result: "앱 구조 개선과 기능 안정화를 통해 서비스 품질 및 사용자 이용 경험 향상",
    background: "전공모아 서비스는 전문대학 전공·대학·입학 정보를 통합 제공하는 모바일 플랫폼으로 다양한 진학 정보 콘텐츠를 보다 안정적이고 효율적으로 제공하기 위해 앱 구조 개선 및 운영 안정화가 필요",
    problem: "전공·대학·입학 정보와 영상·문서 콘텐츠 등 다양한 외부 콘텐츠 연동으로 앱 구조 복잡도가 증가하고 OS 및 디바이스 환경 변화에 대응하기 위한 유지보수 부담이 존재",
    solution: "Android 및 iOS 모바일 앱 전반에 대한 기능 개선과 안정화 작업을 수행하고 전공·대학·입학 정보 콘텐츠 노출 구조를 정비하여 사용자 탐색 흐름을 개선. 기존 기능 개선 및 운영 편의성을 고려한 유지보수 체계를 구축하고 화면 UI 흐름을 정리하여 서비스 사용성을 향상",
    tech: ["Android", "iOS", "Objective-C", "C#"],
    outcome: "모바일 앱 안정성과 서비스 품질 향상, 유지보수 효율 개선을 통한 지속적인 서비스 운영 기반 확보 및 진학 정보 서비스 이용 경험 개선",
    isEdit: true,
    enabled: true
  },
  {
    id: 24,
    category: 'web-mobile',
    title: '현대오토에버 MEXICO 총무시스템 고도화 및 유지보수',
    target: 'WEB & MOBILE',
    year: '2021 ~ 현재',
    summary: '현대오토에버 멕시코 법인의 총무(GA) 업무를 지원하는 내부 시스템 고도화 및 유지보수 프로젝트',
    tags: ['Enterprise', 'Internal System', 'Maintenance'],
    result: '총무 업무 프로세스 표준화 및 운영 효율 향상',
    background: '해외 법인 총무 업무는 수작업과 비표준 프로세스로 인해 업무 처리 지연과 정보 관리 한계가 발생하고 있어 중앙 집중형 총무 시스템 고도화가 필요',
    problem: '종이 문서 및 수작업 중심의 업무 처리로 입력 오류와 정보 유실이 발생하고 승인·요청 프로세스가 복잡하여 총무 업무 운영 효율이 낮은 문제 존재',
    solution: '총무 업무 프로세스를 시스템화하고 문서 이력 관리, 승인 워크플로우, 통계 및 검색 기능을 개선하여 해외 법인 환경에서도 안정적인 운영이 가능하도록 시스템을 고도화',
    tech: ['Java', 'Spring', 'JSP', 'MariaDB', 'JavaScript', 'jQuery'],
    outcome: '총무 업무 처리 시간 단축 및 운영 비용 절감, 해외 법인 총무 업무 운영 안정성 확보',
    isEdit: true,
    enabled: true
  },
  {
    id: 23,
    category: 'web-mobile',
    title: '현대트랜시스 보안포탈시스템 개선기능 개발',
    target: 'WEB & MOBILE',
    year: '2023',
    summary: '현대트랜시스 내부 보안 포탈 시스템의 기능 개선과 사용자 편의성 향상을 위한 보안 포탈 고도화 프로젝트',
    tags: ['Security', 'Portal', 'Enterprise'],
    result: '보안 업무 전산화 및 보안 포탈 운영 효율 개선',
    background: '현대트랜시스 내부 보안 포탈 시스템에서 일부 업무가 수기로 처리되고 있어 업무 처리 효율이 낮고 사용자 편의성이 떨어지는 문제가 발생',
    problem: '보안 관련 신청 및 관리 프로세스가 비효율적으로 운영되고 기존 포탈 UI/UX가 사용자 중심 구조로 설계되지 않아 업무 처리 흐름이 복잡한 문제 존재',
    solution: '보안 포탈 주요 기능을 개선하고 보안 업무 프로세스를 분석하여 전산화된 업무 흐름으로 재구성하고 사용자 중심 UI/UX 개선을 통해 보안 포탈 운영 효율을 높임',
    tech: ['Java', 'Spring', 'JSP', 'JavaScript', 'jQuery', 'Tibero'],
    outcome: '보안 업무 처리 효율을 개선하고 내부 보안 포탈 시스템의 안정적인 운영 환경 구축',
    isEdit: true,
    enabled: true
  },
  {
    id: 22,
    category: "web-mobile",
    title: "SSG Fulfillment Center 시스템 구축",
    target: "WEB & MOBILE",
    year: "2021 ~ 2022",
    summary: "SSG.COM의 3PL 사업을 위한 Fulfillment Center(SFC) 물류 플랫폼 구축 프로젝트",
    tags: ["Logistics", "Platform", "System"],
    result: "대형 이커머스 물류 운영 체계 구축 및 물류 프로세스 안정화",
    background: "SSG.COM의 3PL 사업 확장에 따라 입점 셀러 관리(PLS)와 물류창고 운영(WMS)을 통합 관리할 수 있는 Fulfillment Center 시스템 구축이 필요",
    problem: "입점 셀러 관리, 주문·재고·정산과 실제 물류 흐름(입하·피킹·패킹·출고·회수)을 하나의 플랫폼에서 안정적으로 처리해야 했으며 대규모 트래픽과 복잡한 물류 프로세스를 고려한 시스템 설계가 요구됨",
    solution: "PLS(파트너 물류 관리)와 WMS(창고 관리) 영역을 분리하여 셀러 계약, 상품 관리, 주문·재고·정산 관리 기능을 PLS로 구축하고 입하·피킹·패킹·출고·회수 등 실제 물류 흐름을 WMS로 시스템화. SSG 내부 기획·개발 조직과 협업하여 물류 운영 전반을 지원하는 Fulfillment Center 플랫폼을 공동 구축",
    tech: ["Java", "Spring Boot", "Node.js", "Next.js", "Android", "iOS", "CSS", "Maven"],
    outcome: "SSG.COM Fulfillment Center 물류 플랫폼 구축을 통해 셀러 관리와 물류 운영 프로세스를 통합하고 대형 이커머스 물류 운영의 안정성과 확장 기반 확보",
    isEdit: true,
    enabled: true
  },
  {
    id: 21,
    category: "web-mobile",
    title: "AI 홈로봇 TOKI 2 SW 플랫폼 구축",
    target: "WEB & MOBILE",
    year: "2020 ~ 2021",
    summary: "AI 홈로봇 TOKI 2 서비스를 위한 로봇 관리 플랫폼, 모바일 앱, 로봇 앱, 개발자 센터 및 앱스토어를 통합 구축한 플랫폼 개발 프로젝트",
    tags: ["Platform", "Robot", "IoT", "Mobile"],
    result: "로봇 운영, 사용자 서비스, 콘텐츠 유통을 통합 관리하는 로봇 플랫폼 구축",
    background: "AI 홈로봇 서비스 확장을 위해 로봇 관리, 사용자 서비스, 앱 배포 및 콘텐츠 유통을 하나의 플랫폼에서 통합 운영할 수 있는 시스템 구축 필요",
    problem: "로봇 운영 시스템, 사용자 앱, 앱 배포 및 결제 시스템이 분산되어 있어 서비스 확장성과 운영 효율에 한계가 있었으며 로봇과 서버 간 안정적인 통신 구조가 요구됨",
    solution: "로봇 관리 플랫폼, 모바일 앱, 로봇 앱, 개발자 센터 및 앱스토어를 통합 구축하고 OAuth 기반 통합 계정 인증 구조를 설계. MQTT 기반 로봇 통신 구조와 Push 서비스 기능을 구현하고 앱 등록·배포·결제·정산 기능을 포함한 개발자 생태계를 지원하는 플랫폼을 구축",
    tech: ["Android", "Kotlin", "Objective-C", "Spring Boot", "Vue.js", "iOS"],
    outcome: "로봇 서비스 운영 효율을 향상시키고 사용자·로봇·개발자가 연결되는 플랫폼 기반을 구축하여 향후 서비스 확장 및 상용화 가능 구조 확보",
    isEdit: true,
    enabled: true
  },
  {
    id: 20,
    category: "web-mobile",
    title: "WCG 2021 메인 사이트 및 대회 홍보 사이트 구축",
    target: "WEB & MOBILE",
    year: "2021",
    summary: "WCG 브랜드 강화와 대회 홍보를 위한 메인 사이트 및 대회 홍보 사이트 리뉴얼 구축 프로젝트",
    tags: ["Web", "Promotion", "Platform"],
    result: "대회 및 콘텐츠 운영 프로세스를 시스템화하여 브랜드 커뮤니케이션 및 운영 효율 개선",
    background: "WCG 브랜드 강화와 글로벌 대회 홍보를 위해 메인 사이트와 대회 홍보 사이트 리뉴얼이 필요했으며, 대회 운영을 위한 관리자 기능 및 콘텐츠 관리 구조 정비가 요구됨",
    problem: "대회 및 토너먼트 운영, 참가자 관리, 콘텐츠 운영 기능이 체계적으로 정리되지 않아 운영 효율과 콘텐츠 관리 편의성 개선이 필요",
    solution: "메인 및 대회 홍보 사이트를 리뉴얼하고 토너먼트 운영을 위한 관리자 기능을 구축. 선수·팀·회원 데이터 관리 기능과 대회 생성 및 경기 결과 관리 기능을 반영하고, 라이브·영상·뉴스 등 메인 콘텐츠 운영 구조를 정비하여 대회 운영과 콘텐츠 관리 효율을 향상",
    tech: ["Java", "Spring", "JavaScript", "jQuery", "CSS"],
    outcome: "대회 운영과 콘텐츠 관리 프로세스를 시스템화하여 운영 효율을 개선하고 WCG 브랜드 커뮤니케이션을 강화하는 웹 운영 기반 구축",
    isEdit: true,
    enabled: true
  },
  {
    id: 19,
    category: 'web-mobile',
    title: '슈퍼셀 e-Sports 토너먼트 매칭 플랫폼 구축',
    target: 'WEB & MOBILE',
    year: '2021',
    summary: '슈퍼셀 게임 기반 e-Sports 토너먼트 대회의 생성, 참가 접수, 진행 상태 관리 등을 통합 제공하는 토너먼트 운영 플랫폼 구축 프로젝트',
    tags: ['eSports', 'Tournament', 'Platform'],
    result: '토너먼트 운영 프로세스 자동화 및 사용자 참여 경험 개선',
    background: '슈퍼셀 게임 기반 e-Sports 대회를 효율적으로 운영하고 사용자 참여를 확대하기 위한 전용 토너먼트 플랫폼 필요',
    problem: '대회 생성, 참가 접수, 경기 진행 및 결과 관리가 수작업 중심으로 운영되어 관리 효율과 사용자 참여 경험이 낮은 문제 존재',
    solution: '웹·모바일 기반 e-Sports 토너먼트 플랫폼을 구축하여 대회 생성, 참가 관리, 진행 상태 관리 및 사용자 참여 흐름을 시스템화',
    tech: ['Java', 'Spring Boot', 'JSP', 'jQuery', 'Android', 'iOS'],
    outcome: '토너먼트 운영 관리 시스템을 구축하여 대회 운영 효율성과 사용자 참여 경험을 동시에 개선',
    isEdit: false,
    enabled: true
  },
  {
    id: 18,
    category: 'web-mobile',
    title: '한컴MDS TRACE32(T32) 웹·모바일 렌탈 관리 서비스 구축',
    target: 'WEB & MOBILE',
    year: '2020',
    summary: 'TRACE32 디버깅 장비의 대여·반납·A/S·결제까지 전 과정을 관리할 수 있는 웹·모바일 통합 렌탈 관리 플랫폼 구축 프로젝트',
    tags: ['Platform', 'Rental', 'Management', 'Enterprise'],
    result: 'TRACE32 렌탈 서비스 프로세스 디지털화 및 운영 관리 효율 향상',
    background: 'TRACE32 디버깅 장비 렌탈 서비스를 효율적으로 운영하고 고객에게 편리한 대여·반납·A/S 신청 환경을 제공하기 위한 통합 관리 시스템 구축 필요',
    problem: '기존 오프라인 중심 렌탈 프로세스로 인해 대여·반납 관리, 고객 서비스 이용 현황 확인, A/S 요청 관리 등이 비효율적으로 운영되고 있었음',
    solution: '사용자 모바일 앱(Android/iOS), 영업담당자 모바일 앱, 관리자 웹 포털을 구축하여 TRACE32 장비 렌탈, 결제, A/S 요청, 고객 관리 등을 통합 관리할 수 있는 플랫폼을 구현',
    tech: ['Android', 'iOS', 'Java', 'Spring', 'Hybrid App'],
    outcome: 'TRACE32 장비 렌탈 서비스의 디지털 전환을 통해 운영 효율성과 고객 서비스 편의성 향상',
    isEdit: true,
    enabled: true
  },
  {
    id: 17,
    category: 'web-mobile',
    title: '덕유양조(덕유와이너리) 브랜딩 및 반응형 웹사이트 구축',
    target: 'WEB & MOBILE',
    year: '2020 ~ 2021',
    summary: '덕유양조 브랜드 전략 컨설팅, 홈페이지 리뉴얼 및 온라인 마케팅 전략 수립을 수행한 브랜딩·디지털 전환 프로젝트',
    tags: ['Branding', 'Web', 'Consulting', 'Marketing'],
    result: '브랜드 전략 수립과 웹사이트 구축을 통해 브랜드 이미지 재정립 및 온라인 시장 진출 기반 마련',
    background: '오프라인(군납) 매출 의존도가 높고 온라인 매출 비중이 낮아 브랜드 정체성과 온라인 시장 경쟁력 강화가 필요한 상황',
    problem: '브랜드 스토리 부재, 온라인 콘텐츠 부족, 트렌드가 반영되지 않은 웹사이트와 제품 정보 구조로 인해 온라인 시장 경쟁력이 부족',
    solution: '시장 조사와 트렌드 분석을 기반으로 2030 여성 타겟 중심의 브랜드 전략을 수립하고, 스토리 기반 홈페이지 리뉴얼과 온라인 마케팅 전략 컨설팅을 통해 브랜드 경쟁력을 강화',
    tech: ['React', 'Next.js', 'Tailwind CSS', 'AWS'],
    outcome: '브랜드 전략 컨설팅과 디지털 채널 구축을 통해 온라인 마케팅 기반을 마련하고 브랜드 인지도 향상 및 온라인 매출 확대 기반 확보',
    isEdit: true,
    enabled: true
  },
  {
    id: 16,
    category: 'web-mobile',
    title: '대한통운 오픈 API 통합 연동 플랫폼 구축',
    target: 'WEB & MOBILE',
    year: '2020',
    summary: '외부 파트너 및 이커머스 플랫폼과의 물류 서비스 연동을 위한 REST 기반 오픈 API 통합 플랫폼 구축 프로젝트',
    tags: ['OpenAPI', 'Logistics', 'Integration', 'Platform'],
    result: '외부 시스템 연동 표준화 및 물류 서비스 확장성 확보',
    background: '외부 협력사, 이커머스 플랫폼, ERP 시스템 등 다양한 외부 시스템과의 물류 연동 증가로 표준화된 오픈 API 플랫폼 구축 필요',
    problem: '비표준화된 연동 방식으로 인해 개발 및 유지보수 비용 증가와 신규 파트너사 연동 시 개발 기간 지연 발생',
    solution: 'Spring Boot 기반 REST API와 API Gateway 구조를 적용하여 물류 서비스 연동을 표준화하고 Swagger 기반 API 문서 자동화를 통해 개발자 친화적인 연동 환경을 구축',
    tech: ['AWS', 'Spring Boot', 'Java', 'REST API', 'Swagger'],
    outcome: '물류 서비스 API 표준화를 통해 외부 파트너 연동 효율을 높이고 확장 가능한 물류 연동 플랫폼 기반을 구축',
    isEdit: true,
    enabled: true
  },
  {
    id: 15,
    category: 'web-mobile',
    title: '롯데캐롯손해보험 오픈 API 통합 플랫폼 구축',
    target: 'WEB & MOBILE',
    year: '2020 ~ 2021',
    summary: '외부 파트너사와의 안전하고 효율적인 연동을 위한 보험 오픈 API 통합 플랫폼 구축 프로젝트',
    tags: ['API', 'OpenAPI', 'Fintech', 'Insurance'],
    result: '외부 서비스 연동 표준화 및 금융 API 운영 안정성 확보',
    background: '디지털 보험 시장 확대에 따라 외부 파트너사와의 연동 효율성과 금융권 보안 규정 준수를 동시에 충족할 수 있는 표준 오픈 API 플랫폼 구축 필요',
    problem: '비표준화된 인터페이스로 인해 제휴사별 개별 연동 개발이 반복되고 개발 복잡도와 리소스 소모가 증가했으며, 강화된 인증 체계와 개인정보 보호를 위한 보안 구조가 필요했음',
    solution: 'OAuth 2.0 기반 인증 체계와 Spring Boot 기반 오픈 API 플랫폼을 구축하고, API Gateway 및 표준 REST API 구조를 적용하여 보험료 계산, 청약, 계약 조회, 증권 발급, 사고 접수 등 핵심 보험 서비스를 외부 시스템과 안정적으로 연동할 수 있도록 설계',
    tech: ['AWS', 'Spring Boot', 'Java', 'REST API', 'OAuth 2.0'],
    outcome: '보험 서비스 연동 표준화를 통해 개발 생산성과 Time-to-Market을 개선하고 금융 API 보안성과 운영 안정성을 강화',
    isEdit: true,
    enabled: true
  },
  {
    id: 14,
    category: 'web-mobile',
    title: 'WCG 유지보수 & 리뉴얼',
    target: 'WEB & MOBILE',
    year: '2020',
    summary: 'WCG 메인 및 대회 운영·홍보 사이트의 유지보수 및 단계적 리뉴얼을 수행한 프로젝트',
    tags: ['Web', 'Maintenance', 'Renewal'],
    result: '사이트 운영 안정성 강화 및 콘텐츠 품질 지속 개선',
    background: 'WCG 서비스의 안정적인 운영과 대회 일정·콘텐츠 변경에 유연하게 대응하기 위한 지속적 유지보수 필요',
    problem: '운영 중 발생하는 기술적 이슈와 잦은 콘텐츠 변경 요구로 인해 즉각적인 대응 체계 필요',
    solution: '메인/대회 운영 및 홍보 사이트의 상시 유지보수와 부분 리뉴얼을 통해 안정성과 운영 효율을 강화',
    tech: ['Java', 'Spring Boot'],
    outcome: '운영 안정성 확보와 함께 콘텐츠 개선이 지속적으로 이루어질 수 있는 운영 기반 마련',
    isEdit: false,
    enabled: false
  },
  {
    id: 13,
    category: 'government',
    title: '국립부산과학관 홈페이지 유지보수 및 기능개발',
    target: 'GOVERNMENT',
    year: '2023 ~ 2025',
    summary: '국립부산과학관 대표 홈페이지의 안정적인 운영을 위한 유지보수와 기능 개선, 신규 기능 개발 및 Toss Payments PG 연동을 수행한 운영 고도화 프로젝트',
    tags: ['Public', 'Portal', 'Maintenance', 'Payment'],
    result: '홈페이지 안정적 운영 환경 유지, 사용자 편의 기능 강화 및 온라인 결제 기능 확장',
    background: '국립부산과학관 대표 홈페이지의 안정적인 서비스 운영을 유지하고 지속적인 기능 개선과 추가 개발을 통해 사용자 편의성과 공공 서비스 품질 향상을 위한 유지보수 체계 필요',
    problem: '장기간 운영된 시스템 환경에서 기능 개선 요구와 신규 기능 개발이 지속적으로 발생하며 일부 화면 및 기능에서 성능, 사용성, 웹접근성 기준 개선 필요',
    solution: '홈페이지 전반 유지보수 및 안정화 작업 수행과 함께 기존 기능 개선 및 신규 기능 개발 진행. 관리자 및 사용자 편의 기능 개선, UI 디자인 수정, 데이터 조회 구조 개선 및 성능 최적화를 수행하고, Toss Payments PG 연동을 통해 온라인 결제 기능을 구축하여 서비스 확장성 강화',
    tech: ['Java', 'Spring Framework', '전자정부 표준프레임워크', 'Tomcat', 'FreeMarker', 'MariaDB', 'Linux', 'Toss Payments'],
    outcome: '안정적인 홈페이지 운영 유지와 사용자 편의성 향상, 공공 서비스 품질 및 신뢰도 강화, 온라인 결제 서비스 제공 기반 마련',
    isEdit: true,
    enabled: true
  },
  {
    id: 12,
    category: 'government',
    title: '한국지역난방기술 PMS 기능 개선 및 홈페이지 운영 고도화',
    target: 'GOVERNMENT',
    year: '2021 ~ 현재',
    summary: '공공기관 프로젝트 관리 시스템(PMS) 기능 개선과 기업 홈페이지 디자인 리뉴얼 및 장기 유지보수를 수행한 운영 고도화 프로젝트',
    tags: ['Public', 'PMS', 'Maintenance', 'Upgrade'],
    result: 'PMS 업무 처리 효율 향상 및 홈페이지 정보 전달력 개선을 통한 운영 안정성 강화',
    background: '장기간 운영된 PMS 시스템에서 발생한 사용성 저하와 업무 프로세스 비효율 문제를 개선하고, 노후화된 기업 홈페이지의 정보 구조와 디자인을 재정비하여 내부 업무 시스템과 대외 채널의 일관된 정보 흐름 구축 필요',
    problem: '기존 PMS 시스템은 업무 프로세스 변화에 따른 화면 구조와 기능 구성의 한계로 협업 효율이 저하되고, 홈페이지 역시 노후화된 디자인과 복잡한 정보 구조로 기관 이미지와 정보 전달력이 제한되는 문제 존재',
    solution: 'PMS 핵심 기능 고도화 및 UI/UX 개선을 통해 설계 협업 중심의 업무 프로세스를 반영한 화면 구조 재정비. OZ Report 기반 보고 체계 유지 및 데이터 구조 안정화와 함께 기업 홈페이지 디자인 리뉴얼 및 반응형 웹 적용을 통한 정보 구조 개선',
    tech: ['Java', 'Spring Framework', 'MS SQL', 'Tomcat', 'OZ Report'],
    outcome: 'PMS 업무 처리 효율 및 협업 체계 개선, 장기 운영을 고려한 안정적 시스템 기반 확보와 함께 홈페이지 디자인 개선을 통한 기관 대외 이미지 및 사용자 만족도 향상',
    isEdit: true,
    enabled: true
  },
  {
    id: 11,
    category: 'government',
    title: '보건복지부 국립병원',
    target: 'GOVERNMENT',
    year: '',
    summary: 'EMR 시스템 e-Form을 개발한 프로젝트',
    tags: ['Healthcare', 'e-Form', 'System'],
    result: '문서 전자화로 업무 처리 효율 개선',
    background: '보건복지부 국립병원의 EMR 시스템 전자화 및 업무 효율 개선 필요',
    problem: '종이 기반 문서 처리로 인한 업무 비효율 및 관리 어려움',
    solution: 'EMR 시스템 e-Form 개발을 통한 문서 전자화 및 업무 효율 개선',
    tech: ['Java', 'Spring', 'Oracle', 'e-Form'],
    outcome: '문서 전자화로 업무 처리 효율 개선',
    isEdit : false,
    enabled: false
  },
  {
    id: 10,
    category: 'ai',
    title: '한국도로공사 스마트 CCTV 돌발상황 감지 매니저 구축',
    target: 'A.I',
    year: '2022',
    summary: '스마트 CCTV 기반 AI 돌발상황 감지 데이터를 운영자가 효율적으로 관리·모니터링할 수 있는 운영 관리 시스템 구축 프로젝트',
    tags: ['AI', 'SmartCCTV', 'Monitoring'],
    result: '돌발 이벤트 운영 관리 체계 구축 및 모니터링 기반 대응 효율 개선',
    background: '한국도로공사 스마트 CCTV 기반 AI 돌발상황 감지 결과를 현장에서 빠르게 확인하고 이벤트 이력 및 통계 데이터를 기반으로 운영 판단을 지원하는 관리 시스템 구축 필요',
    problem: '돌발 이벤트 발생 데이터를 운영 기준에 따라 확인·분류하고 이력 기반으로 관리할 체계 부족. 기관 단위 현황 및 통계 기반 운영 판단과 이벤트 조회·검색·필터 기능 표준화 필요',
    solution: '운영자 중심의 관리 기능(현황, 이벤트, 통계, 설정) 설계 및 구현. 감지 이벤트 조회, 검색, 필터 및 이력 관리 기능을 구축하여 운영 프로세스를 시스템화하고 모니터링 및 관리 효율 개선',
    tech: ['Java', 'Spring Boot', 'MyBatis', 'Oracle Database'],
    outcome: '돌발 이벤트 이력 및 통계 기반 운영 관리 체계 구축으로 모니터링 가시성 확보 및 대응 효율 향상',
    isEdit: true,
    enabled: true
  },
  {
    id: 9,
    category: 'ai',
    title: 'SuperShot',
    target: 'A.I',
    year: '2024',
    summary: '스마트폰 영상 기반으로 골프공 궤적을 추적하고 샷 구질을 분석하는 AI Tracer 모바일 앱 개발 프로젝트',
    tags: ['AI', 'ComputerVision', 'Mobile'],
    result: '골프공 궤적 추적 및 구질 분석 경험 구현, 촬영·분석·공유 흐름 기반의 서비스 UX 구축',
    background: '아마추어 골퍼가 필드에서 자신의 샷 구질과 낙구 지점을 정확히 파악하기 어려워, 스마트폰만으로 궤적을 추적하고 구질을 분석하는 모바일 솔루션이 필요했음',
    problem: '작고 빠르게 움직이는 골프공을 영상에서 안정적으로 추적해야 하며, 촬영/업로드부터 분석 결과 확인까지의 사용자 흐름(갤러리·저장·공유 포함)과 학습을 위한 사용자 피드백 수집 체계가 필요했음',
    solution: '모바일에서 영상 촬영/앨범 업로드를 지원하고, AI 기반 트래킹 결과를 라인/퍼팅/스윙/피치 등 효과로 시각화하여 제공하며, 구질(드로우/페이드/훅/슬라이스 등) 확인 및 사용자 피드백 입력을 통해 데이터 품질을 확보하는 서비스 플로우를 구현',
    tech: ['Android', 'iOS', 'Firebase ML Kit (Object Detection/Tracking)', 'Computer Vision', 'Java 17', 'Spring Boot'],
    outcome: '촬영–분석–결과 확인–저장/공유까지의 사용자 경험을 앱으로 제공하고, 학습/운영을 위한 피드백 수집 구조를 마련해 기능 고도화 기반을 구축',
    isEdit: false,
    enabled: false
  },
  {
    id: 8,
    category: 'e-document',
    title: '웰컴저축은행 창구 페이퍼리스 시스템 구축',
    target: 'E-DOCUMENT',
    year: '2021 ~ 2022',
    summary: '창구 업무 디지털화 및 약 70종 전자서식 구축을 통해 태블릿·인감스캐너 연계를 구현한 디지털 창구 페이퍼리스 시스템 구축 프로젝트',
    tags: ['Paperless', 'e-Document', 'Finance', 'Branch'],
    result: '업무 처리 시간 단축 및 영업점 운영 효율 개선 (처리시간 50% 단축, 서명 횟수 7회 → 1회)',
    background: '창구 서비스 품질 향상과 빠른 업무 처리를 위해 종이 기반 창구 업무의 디지털 전환 필요. 다양한 동의서·신청서·부가서류의 체계적 관리와 종이 문서 관련 비용 절감을 위한 페이퍼리스 환경 구축 요구',
    problem: '종이 기반 서류 작성 및 보관 방식으로 인해 창구 업무 처리 지연, 문서 관리 비효율, 컴플라이언스 대응 부담 및 데이터 활용 제약 발생',
    solution: 'OZ e-Form 기반 약 70종 전자서식 구축과 태블릿 모니터·인감스캐너 연동을 통한 디지털 창구 시스템 구현. 전자문서 작성, 저장, 조회, 결재 및 이력 관리 기능과 TSA 시점확인 및 이미지 시스템 저장까지 포함한 전자문서 처리 프로세스 구축',
    tech: ['Java', 'Spring Boot', 'Oracle', 'OZ e-Form', 'Tablet'],
    outcome: '창구 업무 전자문서화를 통한 고객 대기시간 단축, 영업점 업무 효율 향상 및 종이 문서 관련 비용 절감 기반 마련',
    isEdit: true,
    enabled: true
  },
  {
    id: 7,
    category: 'e-document',
    title: 'SK 넥실리스 Digital Factory Paperless 구축',
    target: 'E-DOCUMENT',
    year: '2021',
    summary: '공장 현장 종이 문서를 전자화하여 태블릿 기반으로 문서를 작성·처리할 수 있는 Digital Factory Paperless 시스템 구축 프로젝트',
    tags: ['DigitalFactory', 'Paperless', 'Workflow'],
    result: '현장 문서 전자화 기반 Paperless 업무 환경 구축 및 문서 처리 효율 향상',
    background: 'SK nexilis 공장 현장에서 사용되던 종이 문서를 전자화하고 태블릿 기반으로 문서를 작성 및 처리할 수 있는 Digital Factory Paperless 시스템 구축 필요',
    problem: '종이 기반 현장 문서 관리로 인해 문서 처리 속도가 느리고 업무 프로세스 표준화 및 데이터 활용에 제약 발생',
    solution: 'OZ Report 기반 현장 문서 서식 구성과 태블릿 기반 문서 입력 및 처리 기능 구현. 현장 입력 → 저장 및 전송 → 승인 및 확인으로 이어지는 전자 문서 처리 흐름을 구축하고 문서 상태 관리 및 이력 기반 운영 구조 적용',
    tech: ['Java', 'Spring', 'Vue.js', 'OZ Report', 'Tablet'],
    outcome: '현장 문서 전자화 및 업무 프로세스 표준화를 통해 문서 처리 속도 향상과 운영 효율 개선 기반 마련',
    isEdit: true,
    enabled: true
  },
  {
    id: 6,
    category: 'e-document',
    title: '현대자동차 vattz 시스템',
    target: 'E-DOCUMENT',
    year: '',
    summary: 'MSA 도입 및 프로세스 재정립으로 업무 효율을 최적화한 프로젝트',
    tags: ['MSA', 'Process', 'Optimization'],
    result: '시스템 확장성 강화 및 업무 효율 개선',
    background: '현대자동차 vattz 시스템의 확장성 및 업무 효율 개선 필요',
    problem: '기존 모놀리식 구조의 확장성 제약 및 업무 프로세스 최적화 필요',
    solution: 'MSA 도입 및 프로세스 재정립을 통한 시스템 확장성 강화 및 업무 효율 최적화',
    tech: ['Java', 'Spring Boot', 'Kubernetes', 'Docker', 'Kafka'],
    outcome: '시스템 확장성 강화 및 업무 효율 개선',
    isEdit : false,
    enabled: true
  },
  {
    id: 5,
    category: 'e-document',
    title: '기아자동차 멕시코',
    target: 'E-DOCUMENT',
    year: '',
    summary: 'paperless 구축 프로젝트',
    tags: ['Paperless', 'e-Form', 'Enterprise'],
    result: '문서 처리 간소화 및 현장 운영 효율 개선',
    background: '기아자동차 멕시코 공장의 문서 전자화 및 현장 운영 효율 개선 필요',
    problem: '종이 기반 문서 처리로 인한 현장 업무 비효율 및 관리 어려움',
    solution: 'Paperless 시스템 구축을 통한 문서 처리 간소화 및 현장 운영 효율 개선',
    tech: ['Java', 'Spring Boot', 'Oracle', 'e-Form', 'Tablet'],
    outcome: '문서 처리 간소화 및 현장 운영 효율 개선',
    isEdit : false,
    enabled: false
  },
  {
    id: 4,
    category: 'e-document',
    title: '하나금융TI',
    target: 'E-DOCUMENT',
    year: '',
    summary: 'Digital HR 시스템 구축 프로젝트',
    tags: ['HR', 'Digital', 'System'],
    result: 'HR 업무 프로세스 고도화 및 운영 안정성 강화',
    background: '하나금융TI의 HR 업무 디지털화 및 프로세스 개선 필요',
    problem: 'HR 업무의 효율화 및 디지털 전환을 위한 통합 시스템 필요',
    solution: 'Digital HR 시스템 구축을 통한 HR 업무 프로세스 고도화',
    tech: ['Java', 'Spring Boot', 'Oracle', 'React', 'AWS'],
    outcome: 'HR 업무 프로세스 고도화 및 운영 안정성 강화',
    isEdit : false,
    enabled: false
  },
  {
    id: 3,
    category: 'mydata',
    title: '한국투자증권 MyDATA 플랫폼 구축',
    target: 'MYDATA',
    year: '2021',
    summary: '한국투자증권의 MyDATA 서비스 제공을 위한 고객 금융 데이터 통합 관리 플랫폼 구축 프로젝트',
    tags: ['MyData', 'Platform', 'Finance'],
    result: '데이터 기반 금융 서비스 제공을 위한 MyDATA 플랫폼 구축',
    background: '한국투자증권의 MyDATA 서비스 제공을 위해 다양한 금융 데이터를 통합 관리하고 데이터 기반 서비스를 제공할 수 있는 플랫폼 구축 필요',
    problem: '고객 금융 데이터를 통합 관리하고 MyDATA 서비스를 안정적으로 제공할 수 있는 데이터 플랫폼 및 서비스 구조 부재',
    solution: '고객 금융 데이터 수집 및 통합 관리 기능을 갖춘 MyDATA 플랫폼 구축. 데이터 기반 서비스 제공을 위한 플랫폼 구조 설계 및 서비스 확장을 고려한 시스템 아키텍처 구성',
    tech: ['Java', 'Spring Boot'],
    outcome: '고객 데이터 통합 관리 기반의 MyDATA 플랫폼 구축으로 데이터 기반 금융 서비스 제공 환경 마련',
    isEdit: true,
    enabled: true
  },
  {
    id: 2,
    category: 'mydata',
    title: '쿠도 마이데이터 API 포탈 구축 및 운영',
    target: 'MYDATA',
    year: '2021',
    summary: '쿠도마이데이터의 데이터 자산을 외부 파트너 및 내부 시스템에 안전하게 제공하기 위한 통합 API 포탈 구축 프로젝트',
    tags: ['MyData', 'API', 'Platform', 'Finance'],
    result: 'API 표준화 및 통합 관리 체계 구축을 통한 데이터 제공 효율성 향상',
    background: '쿠도커뮤니케이션은 다양한 데이터 자산을 보유하고 있으나 외부 파트너 및 내부 시스템 간 데이터 연동이 개별적이고 비표준화된 방식으로 이루어져 관리의 어려움과 보안 리스크가 존재. 또한 API 사용 현황 파악과 통합 관리 체계가 부족하여 효율적인 데이터 자산 활용에 제약이 있어 API 제공, 관리, 모니터링을 통합적으로 수행하는 전문 API 포탈 구축 필요',
    problem: 'API 관리 체계 부재로 인해 연계 방식이 비표준화되고 시스템 간 연동 복잡도가 증가하며 운영 및 보안 관리의 어려움 발생',
    solution: 'API 등록, 배포, 모니터링, 폐기 등 API 생명주기 전반을 관리하는 통합 API 포탈 구축. 인증·인가 기반의 표준 API 관리 환경 제공 및 API 사용 통계, 호출 로그 분석, 관리자 대시보드를 통한 실시간 모니터링 기능 구현',
    tech: ['Java', 'Spring Boot', 'MySQL', 'Kafka', 'AWS'],
    outcome: 'API 생명주기 관리 기반의 통합 운영 환경 구축으로 서비스 확장성과 데이터 보안성 강화 및 파트너사 API 활용 환경 개선',
    isEdit: true,
    enabled: true
  },
  {
    id: 1,
    category: 'mydata',
    title: 'KB 카드',
    target: 'MYDATA',
    year: '',
    summary: 'MyDATA 플랫폼 구축 프로젝트',
    tags: ['MyData', 'Platform', 'Finance'],
    result: '데이터 통합 기반 강화 및 운영 안정성 확보',
    background: 'KB 카드의 MyDATA 서비스 제공을 위한 플랫폼 구축 필요',
    problem: '카드 데이터 통합 관리 및 MyDATA 서비스 제공을 위한 플랫폼 필요',
    solution: 'MyDATA 플랫폼 구축을 통한 데이터 통합 기반 강화 및 운영 안정성 확보',
    tech: ['Java', 'Spring Boot', 'Oracle', 'Kafka', 'AWS'],
    outcome: '데이터 통합 기반 강화 및 운영 안정성 확보',
    isEdit : false,
    enabled: false
  },
];